import moment from 'moment';
import fields from "./fields.utils.js";
import {contactHeadline, defaultFields, percentageGroup, policyHeadline} from "../../utils/step.fields.utils";
import fields_utils from "./fields.utils.js";


const schema_public_liability = {
    ...fields.notes,
    "company_turnover": {
        type: 'select',
        label: 'Company Turnover',
        value: '',
        options: [],
        placeholder: 'Company Turnover',
        orderOptions: false,
    },
    //source
    "source_uuid": {
        type: 'select',
        label: 'source',
        value: '',
        options: [],
        required: true
    },
    "address1": {
        label: "Address Line 1",
        placeholder: "Address Line 1",
        value: '',
        type: "text",
        required: true,
    },
    "address2": {
        label: "Address Line 2",
        placeholder: "Address Line 2",
        value: '',
        type: "text",
    },
    "address3": {
        label: "Address Line 3",
        placeholder: "Address Line 3",
        type: "text",
        value: '',

    },
    "address4": {
        label: "Address Line 4",
        placeholder: "Address Line 4",
        type: "text",
        value: '',
    },
    "city": {
        label: "City",
        placeholder: "City",
        type: "text",
        value: '',
        required: true,

    },
    "postcode": {
        label: 'Postal Code',
        placeholder: 'Postal Code',
        type: "address-lookup",
        value: '',
        required: true,

    },
    "first_name": {
        label: "First Name",
        placeholder: "First Name",
        type: "text",
        value: '',
        required: true,

    },
    "last_name": {
        label: "Last Name",
        placeholder: "Last Name",
        type: "text",
        value: '',
        required: true,

    },
    "date_of_birth": {
        label: 'Date of birth',
        type: 'date-mask',
        value: '',
        required: true,

        placeholder: 'Date of Birth'
    },
    "occupation_x_type": {
        value: '',
        type: 'auto-suggest',
        label: 'Trade / Business',
        required: true,
        options: [],
    },
    "email": {
        label: 'Email Address',
        placeholder: 'Email Address',
        type: 'email',
        value: '',

    },
    "telephone": {
        label: "Telephone",
        placeholder: "Telephone",
        type: "text",
        value: '',
        required: true,
    },
    "cover_date": {
        label: 'Cover Date',
        type: 'date-picker',
        value: moment().format("DD/MM/YYYY"),
        required: true,
        placeholder: 'Cover Date'
    },
    "cover_level": {
        type: 'select',
        label: 'COVER LEVEL',
        value: '',
        options: [],
        placeholder: 'Cover Level',
        orderOptions: false,
    },
    "company_name": {
        label: 'Business Trading Name',
        placeholder: 'Company name',
        type: 'text',
        value: '',
    },
    "company_year": {
        label: "company establishment date (Year)",
        required: true,
        type: 'date-drop-down',
        value: moment().format('YYYY'),
        autocomplete: 'off',
        dateOrder: ['year'],
        placeholder: 'Year'
    },


    has_employees: {
        label: 'Do you have any employees?',
        type: 'bool',
        value: false,
        options: [{key: false, value: 'no'}, {key: true, value: 'yes'}],
        required: true,
    },

    requires_employees_liability_cover: defaultFields.requires_employees_liability_cover,

    ...fields.marketing,
    ...fields.title,
    ...fields.cross_selling
};
export default schema_public_liability;
